import { ClbMixin } from '@utils/ClbMixin'

export const registerElement =
  (name: string) => (Class: CustomElementConstructor) => {
    ;(Class as ReturnType<typeof ClbMixin>).tagName = name
    if (!window.customElements.get(name)) {
      window.customElements.define(name, Class)
    }
  }
